module.exports = __webpack_public_path__ + "img/team-member-3.cad62891.png";